import { useEffect, useState } from 'react';
import { BASE_URL } from '../constants/urls';
import axios from 'axios';
import { pushEvent } from '../utils/dataLayer';

const useTopCoupons = ({ page, limit, type, category }) => {
  const [couponsResponse, setCouponsResponse] = useState({ data: [] });
  const [loadingCoupons, setLoadingCoupons] = useState(true);
  const [errorCoupons, setErrorCoupons] = useState(null);

  useEffect(() => {
    const fetchTopCoupons = async () => {
      setLoadingCoupons(true);
      try {
        const res = await axios.get(`${BASE_URL}/coupon/top`, {
          params: {
            page: page || 1,
            limit: limit || 12,
            type: type || undefined,
            category: category || undefined,
          },
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
          },
        });

        setCouponsResponse({ ...res.data, data: res.data.data || [] });
        setErrorCoupons(null);
      } catch (err) {
        const msg = err?.response?.data?.message || err.message || 'Erro desconhecido';
        setErrorCoupons(msg);
        setCouponsResponse({ data: [] });
      } finally {
        setLoadingCoupons(false);
        pushEvent('CupomCarregadoLoadings');
      }
    };

    fetchTopCoupons();
  }, [page, limit, type, category]);

  return {
    couponsResponse,
    coupons: couponsResponse.data,
    totalPages: couponsResponse.totalPages || 0,
    loadingCoupons,
    errorCoupons,
  };
};

export default useTopCoupons;
